import React, { useState, useCallback } from "react";
import ApplyOnlineForm from "./ApplyOnlineForm/ApplyOnlineForm";
import "./style.scss";

const ApplyOnline = () => {
  const [stepStatus, setStepStatus] = useState<Record<string, string>>({
    one: "",
    two: "",
    three: "",
    four: "",
  });

  const handleStatusChange = useCallback((status: Record<string, string>) => {
    setStepStatus(status);
  }, []);

  return (
    <div className="apply-online">
      <div className="apply-online-steps">
        <div className="apply-online-step one">
          <div
            className={`apply-online-step-point one isWasEmpty ${
              stepStatus.one ? stepStatus.one : "empty"
            }`}
          ></div>
          <span
            className={`apply-online-step-title one active ${
              stepStatus.one ? stepStatus.one : "empty"
            }`}
          >
            Быстрая заявка
          </span>
        </div>

        <div className="apply-online-steps-line"></div>

        <div className="apply-online-step two">
          <div
            className={`apply-online-step-point two ${stepStatus.two ? stepStatus.two : "empty"}`}
          ></div>
          <span
            className={`apply-online-step-title two ${stepStatus.two ? stepStatus.two : "empty"}`}
          >
            Дополнительная информация
          </span>
        </div>

        <div className="apply-online-steps-line"></div>

        <div className="apply-online-step three">
          <div
            className={`apply-online-step-point three ${
              stepStatus.three ? stepStatus.three : "empty"
            }`}
          ></div>
          <span
            className={`apply-online-step-title three ${
              stepStatus.three ? stepStatus.three : "empty"
            }`}
          >
            Детали программы
          </span>
        </div>

        <div className="apply-online-steps-line"></div>

        <div className="apply-online-step four">
          <div
            className={`apply-online-step-point ${stepStatus.four ? stepStatus.four : "empty"}`}
          ></div>
          <span
            className={`apply-online-step-title four ${
              stepStatus.four ? stepStatus.four : "empty"
            }`}
          >
            успешная отправка
          </span>
        </div>
      </div>

      <ApplyOnlineForm onSectionStatusChange={handleStatusChange} />
    </div>
  );
};

export default ApplyOnline;
